// src/data/bookingData.js

export const placeholderBookedDates = [
  new Date("2025-10-18T12:00:00"),
  new Date("2025-11-09T12:00:00"),
  new Date("2025-11-22T12:00:00"),
  new Date("2025-12-12T12:00:00"),
  new Date("2025-12-20T12:00:00"),
];

export const bookingPackages = {
  en: {
    personal: [
      {
        id: "acoustic",
        title: "Solo Acoustic Performance",
        description:
          "Perfect for intimate gatherings, restaurants, or private dinners.",
        features: [
          "2-hour solo performance",
          "Covers and original songs",
          "Ideal for up to 50 guests",
        ],
        gallerySlug: "solo-acoustic",
      },
      {
        id: "full-party",
        title: "Full Band Party Experience",
        description:
          "The complete 'Estilo Sierreño' sound for birthdays, anniversaries, and parties.",
        features: [
          "3-hour performance with band",
          "Professional sound equipment",
          "Guaranteed to get guests dancing",
        ],
        gallerySlug: "full-band-party",
      },
      {
        id: "wedding",
        title: "Wedding & Quinceañera Special",
        description:
          "A tailored, unforgettable musical experience for your most important day.",
        features: [
          "Customizable setlist & duration",
          "Special song requests accommodated",
          "MC services available",
        ],
        gallerySlug: "weddings-special",
      },
    ],
    commercial: [
      {
        id: "venue-headliner",
        title: "Venue Headliner",
        description:
          "A full concert experience designed to pack the house at clubs and theaters.",
        features: [
          "90-minute headline set",
          "Full band performance",
          "Promotional support on social media",
        ],
        gallerySlug: "venue-concerts",
      },
      {
        id: "opening-act",
        title: "Opening Act",
        description:
          "A high-energy opening set to warm up the crowd for a national or regional act.",
        features: [
          "30-45 minute set",
          "Solo or full band available",
          "Professional and punctual",
        ],
        gallerySlug: "solo-acoustic",
      },
      {
        id: "corporate",
        title: "Corporate Entertainment",
        description:
          "Professional and engaging live music for company parties and corporate events.",
        features: [
          "Customizable performance style",
          "Background or featured music",
          "Reliable and professional service",
        ],
        gallerySlug: "full-band-party",
      },
    ],
  },
  es: {
    personal: [
      {
        id: "acoustic",
        title: "Actuación Acústica en Solitario",
        description:
          "Perfecto para reuniones íntimas, restaurantes o cenas privadas.",
        features: [
          "Actuación de 2 horas en solitario",
          "Covers y canciones originales",
          "Ideal para hasta 50 invitados",
        ],
        gallerySlug: "solo-acoustic",
      },
      {
        id: "full-party",
        title: "Experiencia de Fiesta con Banda Completa",
        description:
          "El sonido completo 'Estilo Sierreño' para cumpleaños, aniversarios y fiestas.",
        features: [
          "Actuación de 3 horas con banda",
          "Equipo de sonido profesional",
          "Garantizado para hacer bailar a los invitados",
        ],
        gallerySlug: "full-band-party",
      },
      {
        id: "wedding",
        title: "Especial de Bodas y Quinceañeras",
        description:
          "Una experiencia musical inolvidable y a medida para tu día más importante.",
        features: [
          "Setlist y duración personalizables",
          "Se aceptan peticiones de canciones especiales",
          "Servicios de maestro de ceremonias disponibles",
        ],
        gallerySlug: "weddings-special",
      },
    ],
    commercial: [
      {
        id: "venue-headliner",
        title: "Artista Principal para Salas",
        description:
          "Un concierto completo diseñado para llenar salas de conciertos y teatros.",
        features: [
          "Set principal de 90 minutos",
          "Actuación con banda completa",
          "Apoyo promocional en redes sociales",
        ],
        gallerySlug: "venue-concerts",
      },
      {
        id: "opening-act",
        title: "Acto de Apertura",
        description:
          "Un set de apertura de alta energía para animar al público antes de un acto nacional o regional.",
        features: [
          "Set de 30-45 minutos",
          "Disponible en solitario o con banda completa",
          "Profesional y puntual",
        ],
        gallerySlug: "solo-acoustic",
      },
      {
        id: "corporate",
        title: "Entretenimiento Corporativo",
        description:
          "Música en vivo profesional y atractiva para fiestas de empresa y eventos corporativos.",
        features: [
          "Estilo de actuación personalizable",
          "Música de fondo o principal",
          "Servicio fiable y profesional",
        ],
        gallerySlug: "full-band-party",
      },
    ],
  },
};

// Other exports (faqs, testimonials) remain the same
export const faqs = {
  en: [
    {
      question: "How far are you willing to travel?",
      answer:
        "I am based in Salinas, CA and primarily serve the Central Coast and Bay Area. I am open to traveling further for special events. Travel fees may apply for locations outside a 50-mile radius.",
    },
    {
      question: "Do you provide your own sound equipment?",
      answer:
        "Yes, for most events, I provide a professional-grade sound system suitable for venues of up to 150 guests. For larger events, additional sound reinforcement may be required.",
    },
    {
      question: "Can we request specific songs?",
      answer:
        "Absolutely! I'm happy to learn a few special songs for your event, provided I am given at least one month's notice. We can discuss this during our consultation.",
    },
    {
      question: "What are your payment and deposit policies?",
      answer:
        "A 50% deposit is required to secure your date. The remaining balance is due on the day of the event before the performance begins. I accept various forms of payment for your convenience.",
    },
  ],
  es: [
    {
      question: "¿Qué tan lejos está dispuesto a viajar?",
      answer:
        "Estoy basado en Salinas, CA y sirvo principalmente a la Costa Central y el Área de la Bahía. Estoy abierto a viajar más lejos para eventos especiales. Pueden aplicarse tarifas de viaje para ubicaciones fuera de un radio de 50 millas.",
    },
    {
      question: "¿Proporciona su propio equipo de sonido?",
      answer:
        "Sí, para la mayoría de los eventos, proporciono un sistema de sonido de calidad profesional adecuado para lugares de hasta 150 invitados. Para eventos más grandes, puede ser necesario un refuerzo de sonido adicional.",
    },
    {
      question: "¿Podemos solicitar canciones específicas?",
      answer:
        "¡Por supuesto! Estaré encantado de aprender algunas canciones especiales para su evento, siempre que se me avise con al menos un mes de anticipación. Podemos discutir esto durante nuestra consulta.",
    },
    {
      question: "¿Cuáles son sus políticas de pago y depósito?",
      answer:
        "Se requiere un depósito del 50% para asegurar su fecha. El saldo restante se debe pagar el día del evento antes de que comience la actuación. Acepto varias formas de pago para su comodidad.",
    },
  ],
};

export const testimonials = {
  en: [
    {
      quote:
        "Marino was the highlight of our wedding! His music created the perfect atmosphere, and our guests couldn't stop complimenting his performance. Truly unforgettable.",
      author: "Jessica & Michael R.",
      context: "Wedding Clients",
    },
    {
      quote:
        "We hired Marino for a corporate event, and he was incredibly professional and talented. He set a great vibe for the evening. We will definitely be booking him again.",
      author: "Amanda Chen",
      context: "Event Coordinator, TechCorp",
    },
    {
      quote:
        "As a venue owner, I've seen many artists. Marino's 'estilo sierreño' is authentic and captivating. He always draws a great crowd and is a pleasure to work with.",
      author: "Carlos Gutierrez",
      context: "Owner, La Cantina",
    },
  ],
  es: [
    {
      quote:
        "¡Marino fue lo más destacado de nuestra boda! Su música creó la atmósfera perfecta y nuestros invitados no paraban de elogiar su actuación. Verdaderamente inolvidable.",
      author: "Jessica y Michael R.",
      context: "Clientes de Boda",
    },
    {
      quote:
        "Contratamos a Marino para un evento corporativo y fue increíblemente profesional y talentoso. Creó un gran ambiente para la noche. Definitivamente lo contrataremos de nuevo.",
      author: "Amanda Chen",
      context: "Coordinadora de Eventos, TechCorp",
    },
    {
      quote:
        "Como dueño de un local, he visto a muchos artistas. El 'estilo sierreño' de Marino es auténtico y cautivador. Siempre atrae a una gran multitud y es un placer trabajar con él.",
      author: "Carlos Gutiérrez",
      context: "Propietario, La Cantina",
    },
  ],
};
